import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 95%;
    max-width: 800px;
    margin: 20px auto;
    padding: 30px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(245, 102, 7, 0.3);
`;

const ArchivedBanner = styled.div`
    width: 100%;
    padding: 14px 18px;
    margin-bottom: 24px;
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 8px;
    color: #664d03;
    font-size: 0.95em;
    text-align: center;
    font-weight: 600;
`;

const Heading = styled.h1`
    font-size: 1.8em;
    margin-bottom: 8px;
    text-align: center;
    color: #6c757d;
`;

const SubHeading = styled.p`
    font-size: 0.95em;
    margin-bottom: 25px;
    text-align: center;
    color: #999;
    font-style: italic;
`;

const SectionHeading = styled.h2`
    font-size: 1.25em;
    margin-top: 28px;
    margin-bottom: 12px;
    color: #6c757d;
    border-bottom: 2px solid #adb5bd;
    padding-bottom: 6px;
    align-self: flex-start;
    width: 100%;
`;

const Paragraph = styled.p`
    font-size: 0.95em;
    line-height: 1.6;
    text-align: justify;
    margin-bottom: 12px;
    width: 100%;
    color: #555;
`;

const NewVersionNotice = styled.div`
    margin-top: 50px;
    padding: 25px;
    background-color: #fff5ee;
    border: 2px solid #f56607;
    border-radius: 10px;
    width: 100%;
    text-align: center;
`;

const NoticeTitle = styled.h3`
    font-size: 1.2em;
    color: #f56607;
    margin: 0 0 10px 0;
`;

const NoticeText = styled.p`
    font-size: 0.95em;
    color: #333;
    margin-bottom: 18px;
    line-height: 1.5;
`;

const AmendmentNote = styled.div`
    width: 100%;
    margin-bottom: 24px;
    padding: 16px 20px;
    background-color: #fff5ee;
    border: 1px solid #f56607;
    border-radius: 10px;
    font-size: 0.92em;
    line-height: 1.6;
    color: #333;

    strong {
        color: #b44a03;
    }
`;

const VersionDivider = styled.hr`
    width: 100%;
    border: none;
    border-top: 3px double #f56607;
    margin: 48px 0 8px;
`;

const NewVersionLink = styled(Link)`
    display: inline-block;
    padding: 12px 24px;
    background-color: #f56607;
    color: #fff;
    border-radius: 8px;
    text-decoration: none;
    font-weight: bold;
    font-size: 1em;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #d4570a;
    }
`;

const TermsOfServiceArchive: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <PageContainer>
            <ArchivedBanner>
                ARCHÍV — Toto je staršia, neaktuálna verzia obchodných podmienok. Aktuálne platné
                znenie nájdete na stránke <Link to="/podmienky" style={{ color: "#664d03", textDecoration: "underline" }}>/podmienky</Link>.
            </ArchivedBanner>

            <Heading>VŠEOBECNÉ OBCHODNÉ PODMIENKY</Heading>
            <SubHeading>(verzia zo 14.05.2026 — platná do 18.08.2026)</SubHeading>

            <Paragraph>
                Tieto všeobecné obchodné podmienky (ďalej len „VOP“) poskytovateľa Góly a Esá s. r. o.,
                sídlo spoločnosti: Čs. armády 1593/4, 069 01 Snina, IČO: 57612048, zápis v Obchodnom
                registri Okresného súdu Prešov: 720-22946, Oddiel: Sro, Vložka číslo: 52558/P (ďalej
                len „Poskytovateľ“) vymedzujú práva a povinnosti poskytovateľa a registrovaných
                užívateľov (ďalej len „Objednávateľ“) aplikácie Góly a Esá.
            </Paragraph>
            <Paragraph>
                VOP sú vypracované v súlade s platnými právnymi predpismi Slovenskej republiky
                a spravujú sa najmä ustanoveniami zákona č. 513/1991 Zb. Obchodný zákonník (ďalej len
                „Obchodný zákonník“), zákona č. 40/1964 Zb. Občiansky zákonník (ďalej len „Občiansky
                zákonník“), zákona č. 18/2018 Z. z. o ochrane osobných údajov a o zmene a doplnení
                niektorých zákonov (ďalej len „Zákon o ochrane osobných údajov“), nariadenia Európskeho
                parlamentu a Rady (EÚ) č. 2016/679 z 27. apríla 2016 o ochrane fyzických osôb pri
                spracúvaní osobných údajov a o voľnom pohybe takýchto údajov (ďalej len „GDPR“).
            </Paragraph>

            <SectionHeading>Úvodné ustanovenia</SectionHeading>
            <Paragraph>
                Tieto VOP upravujú práva a povinnosti medzi Poskytovateľom a Objednávateľom pri
                poskytovaní poradenských služieb v oblasti tipovania športových zápasov (ďalej len
                „Služby“).
            </Paragraph>
            <Paragraph>
                Objednávateľ registráciou v aplikácií Góly a Esá a zaplatením členského poplatku
                uvedeného v aplikácií súhlasí so spracovaním osobných údajov v súlade so Zákonom
                o ochrane osobných údajov za účelom riadneho poskytnutia Služby.
            </Paragraph>

            <SectionHeading>Objednávka</SectionHeading>
            <Paragraph>
                Poskytovateľ registráciou Objednávateľa v aplikácií Góly a Esá a zaplatením členského
                poplatku uvedeného v aplikácií prostredníctvom platobnej brány Stripe sprístupní
                Objednávateľovi platený obsah v aplikácií na zakúpené obdobie od prijatia platby.
                Varianty zakúpeného obdobia sú: 1 deň, 1 mesiac, 3 mesiace a 1 rok.
            </Paragraph>
            <Paragraph>
                Objednávateľ zaplatením členského poplatku potvrdzuje, že sa oboznámil s VOP.
            </Paragraph>
            <Paragraph>
                Zaplatením členského poplatku Objednávateľ získava členstvo na zakúpené obdobie.
            </Paragraph>
            <Paragraph>
                Uplynutím zakúpeného obdobia od zaplatenia členského poplatku v prípade, že
                Objednávateľ má opätovný záujem o prístup k platenému obsahu aplikácie, tak je potrebné
                znova uhradiť členský poplatok uvedený v aplikácií prostredníctvom platobnej brány
                Stripe, čím sa mu obdobie predĺži o zvolenú variantu zakúpeného obdobia.
            </Paragraph>
            <Paragraph>
                Všetky ceny sú konečné, vrátane všetkých daní. Všetky ceny sú aktualizované a platné.
            </Paragraph>
            <Paragraph>
                Nefunkčnosť aplikácie nie je dôvod na vrátenie alikvotnej časti členského poplatku.
            </Paragraph>

            <SectionHeading>Podmienky používania aplikácie</SectionHeading>
            <Paragraph>
                Objednávateľ berie na vedomie a súhlasí, že poskytované informácie majú informatívny
                charakter a nie sú spracovávané a prezentované ako informácie na mieru pre konkrétneho
                užívateľa ale pre širokú verejnosť. Zároveň berie na vedomie, že Poskytovateľ
                nezaručuje, že každý užívateľ pri uplatňovaní jeho rád, dosiahne želaný výsledok,
                nakoľko výsledok ovplyvňuje aj rýchlosť reakcie, kurzové rozdiely, ovplyvnenie výsledku
                iným podnetom, ktoré Poskytovateľ nemôže ovplyvniť a nemá na to dosah. Preto pokiaľ
                Objednávateľ nedosiahne želaného výsledku, nie je to dôvod na vrátenie členského
                poplatku.
            </Paragraph>
             <Paragraph>
                Registráciou na stránke Objednávateľ súhlasí so zasielaním informačných e-mailov
                súvisiacich s obsahom stránky. Tento súhlas je možné kedykoľvek odvolať a Poskytovateľ
                vyradí e-mail Objednávateľa z databázy.
            </Paragraph>
            <Paragraph>
                Ak nie je uvedené inak, celý text, videá, služby a ostatné informácie uvedené
                v aplikácií sú duševným vlastníctvom Poskytovateľa. V aplikácií je dovolené sledovať
                videá, články pokiaľ si ich Objednávateľ zakúpil.
            </Paragraph>
            <Paragraph>
                Nie je dovolené poskytovať prístup tretím osobám, ktoré si ho nezakúpili. Pokiaľ
                Poskytovateľ zistí porušenie tohto pravidla, má právo zrušiť platený obsah v aplikácií
                bez nároku na vrátenie členského poplatku.
            </Paragraph>
            <Paragraph>
                Ak Poskytovateľ zistí takéto závažné porušenie povinností Objednávateľom, tak je
                oprávnený žiadať o úhradu zmluvnej pokuty vo výške 5000 eur a to do 15 dní od doručenia
                výzvy Objednávateľovi, ktorý sa tohto konania dopustil. Úhradou zmluvnej pokuty však
                nezaniká nárok Poskytovateľa na náhradu škody, ktorá vznikla takýmto konaním
                Objednávateľa.
            </Paragraph>
            <Paragraph>
                Nie je dovolené publikovať obsah aplikácie, videá alebo články na internete (na inej
                webovej stránke, na stránkach na zdieľanie súborov, na stránkach na zdieľanie videí či
                na sociálnej sieti).
            </Paragraph>
            <Paragraph>
                Prevádzkovateľ si vyhradzuje právo možnosti ukončiť členstvo Objednávateľa skôr ako
                uplynie lehota zakúpeného obdobia, ak sa Objednávateľ správa neúctivo, urážlivo voči
                Poskytovateľovi alebo ostatným Objednávateľom.
            </Paragraph>
            <Paragraph>
                Predčasným ukončením členstva nevzniká nárok na vrátenie zaplateného členského poplatku
                ani jeho alikvotnej čiastky.
            </Paragraph>

            <SectionHeading>Informácie o rizikách</SectionHeading>
            <Paragraph>
                Poskytovateľ výslovne upozorňuje Objednávateľa, že stávkovanie na športové zápasy je
                aktivita zahŕňajúca riziká.
            </Paragraph>
            <Paragraph>
                Objednávateľ výslovne uznáva, že straty dosiahnuté pri stávkovaní na športové zápasy
                a kurzovú ponuku znáša v plnom rozsahu sám a Poskytovateľ v tomto prípade nenesie
                žiadnu zodpovednosť.
            </Paragraph>
            <Paragraph>
                Rozhodnutie Objednávateľa o stavení sumy je jeho individuálnym, slobodným a vážnym
                rozhodnutím, za ktoré Poskytovateľ v žiadnom prípade nezodpovedá.
            </Paragraph>
            <Paragraph>
                Poskytovateľ nezodpovedá Objednávateľovi za straty, ktoré mu vzniknú v dôsledku
                stávkovania.
            </Paragraph>

            <SectionHeading>Ochrana osobných údajov</SectionHeading>
            <Paragraph>
                Poskytovateľ rešpektuje dôverný charakter dát, ktoré sú mu poskytované v súlade so
                Zákonom o ochrane osobných údajov a GDPR a zabezpečuje ich ochranu proti zneužitiu.
                Dáta sú predovšetkým používané na účtovné operácie, vystavenie daňových dokladov,
                identifikáciu bezhotovostných platieb a v rámci administratívy.
            </Paragraph>

            <SectionHeading>Riešenie sporov</SectionHeading>
            <Paragraph>
                Tieto VOP sa riadia právom Slovenskej republiky s vylúčením kolíznych noriem, ktoré by
                odkazovali na použitie cudzieho práva.
            </Paragraph>
            <Paragraph>
                Právom Slovenskej republiky sa spravujú právne vzťahy medzi Poskytovateľom
                a Objednávateľom aj vtedy, ak Objednávateľ nie je občanom Slovenskej republiky alebo
                nemá na jej území pobyt alebo sídlo, ako aj v prípade, že Služba sa poskytuje mimo
                územia Slovenskej republiky.
            </Paragraph>
            <Paragraph>
                V prípade akéhokoľvek sporu medzi Poskytovateľom a Objednávateľom, vzniknutého
                v súvislosti s týmito VOP sa Poskytovateľ a Objednávateľ zaväzujú vynaložiť najvyššie
                možné úsilie, ktoré je možné od nich spravodlivo požadovať, aby spory vyriešili
                mimosúdnou cestou a dosiahli uzavretie zmieru na základe vzájomnej dohody.
            </Paragraph>
            <Paragraph>
                V prípade, že nedôjde k vyriešeniu sporu mimosúdnou cestou a uzavretiu zmieru budú
                všetky spory medzi Poskytovateľom a Objednávateľom rozhodované príslušnými súdmi
                Slovenskej republiky podľa všeobecne záväzných právnych predpisov Slovenskej republiky.
            </Paragraph>

            <SectionHeading>Záverečné ustanovenia</SectionHeading>
            <Paragraph>
                Tieto VOP sú záväzné pre všetkých Objednávateľov aplikácie Góly a Esá. Pred zaplatením
                členského poplatku sú všetci Objednávatelia povinní sa riadne oboznámiť s aktuálnym
                znením VOP a zaväzujú sa nimi riadiť a dodržiavať ich.
            </Paragraph>
            <Paragraph>
                V prípade, že akékoľvek ustanovenie týchto VOP sa stane neplatným, neúčinným,
                nevykonateľným, tak nie je tým dotknutá platnosť, účinnosť, vykonateľnosť ostatných
                ustanovení týchto VOP. Neplatné, neúčinné, nevykonateľné ustanovenie sa nahradí v čo
                najkratšej dobe novým platným ustanovením.
            </Paragraph>
            <Paragraph>
                Tieto VOP budú počas celej doby ich platnosti zverejnené v aplikácií Góly a Esá,
                pričom Poskytovateľ si vyhradzuje právo kedykoľvek vykonávať zmeny alebo dodatky
                týchto VOP bez predchádzajúceho súhlasu Objednávateľa. Takto upravené alebo zmenené
                alebo doplnené VOP je Poskytovateľ povinný bezodkladne zverejniť v aplikácií Góly
                a Esá.
            </Paragraph>
            <Paragraph>
                Tieto VOP nadobúdajú platnosť a účinnosť dňom ich zverejnenia v aplikácií Góly a Esá.
            </Paragraph>

            <VersionDivider />

            <Heading>VŠEOBECNÉ OBCHODNÉ PODMIENKY</Heading>
            <SubHeading>(staršia verzia — poskytovateľ Maroš Šmajda)</SubHeading>

            <Paragraph>
                Tieto všeobecné obchodné podmienky (ďalej len „VOP“) poskytovateľa Maroš Šmajda,
                miesto podnikania: Čs. armády 1593/4, 069 01 Snina, IČO: 51300656, číslo
                živnostenského registra: 720-22946, vedený v registri Okresného úradu Humenné (ďalej
                len „Poskytovateľ“) vymedzujú práva a povinnosti poskytovateľa a registrovaných
                užívateľov (ďalej len „Objednávateľ“) aplikácie Góly a Esá.
            </Paragraph>
            <Paragraph>
                VOP sú vypracované v súlade s platnými právnymi predpismi Slovenskej republiky
                a spravujú sa najmä ustanoveniami zákona č. 513/1991 Zb. Obchodný zákonník (ďalej len
                „Obchodný zákonník“), zákona č. 40/1964 Zb. Občiansky zákonník (ďalej len „Občiansky
                zákonník“), zákona č. 18/2018 Z. z. o ochrane osobných údajov a o zmene a doplnení
                niektorých zákonov (ďalej len „Zákon o ochrane osobných údajov“), nariadenia Európskeho
                parlamentu a Rady (EÚ) č. 2016/679 z 27. apríla 2016 o ochrane fyzických osôb pri
                spracúvaní osobných údajov a o voľnom pohybe takýchto údajov (ďalej len „GDPR“).
            </Paragraph>
            <Paragraph>
                Registráciou na stránke Objednávateľ súhlasí so zasielaním informačných e-mailov
                súvisiacich s obsahom stránky. Tento súhlas je možné kedykoľvek odvolať a Poskytovateľ
                vyradí e-mail Objednávateľa z databázy.
            </Paragraph>

            <SectionHeading>Úvodné ustanovenia</SectionHeading>
            <Paragraph>
                Tieto VOP upravujú práva a povinnosti medzi Poskytovateľom a Objednávateľom pri
                poskytovaní poradenských služieb v oblasti tipovania športových zápasov (ďalej len
                „Služby“).
            </Paragraph>
            <Paragraph>
                Objednávateľ registráciou v aplikácií Góly a Esá a zaplatením členského poplatku
                uvedeného v aplikácií súhlasí so spracovaním osobných údajov v súlade so Zákonom
                o ochrane osobných údajov za účelom riadneho poskytnutia Služby.
            </Paragraph>

            <SectionHeading>Objednávka</SectionHeading>
            <Paragraph>
                Poskytovateľ registráciou Objednávateľa v aplikácií Góly a Esá a zaplatením členského
                poplatku uvedeného v aplikácií prostredníctvom platobnej brány Stripe sprístupní
                Objednávateľovi platený obsah v aplikácií na obdobie jedného mesiaca od prijatia
                platby.
            </Paragraph>
            <Paragraph>
                Objednávateľ zaplatením členského poplatku potvrdzuje, že sa oboznámil s VOP.
            </Paragraph>
            <Paragraph>
                Zaplatením členského poplatku Objednávateľ získava členstvo na obdobie jedného
                mesiaca.
            </Paragraph>
            <Paragraph>
                Uplynutím jedného mesiaca od zaplatenia členského poplatku v prípade, že Objednávateľ
                má opätovný záujem o prístup k platenému obsahu aplikácie, tak je potrebné znova
                uhradiť členský poplatok uvedený v aplikácií prostredníctvom platobnej brány Stripe,
                čím sa mu obdobie predĺži o jeden mesiac.
            </Paragraph>
            <Paragraph>
                Všetky ceny sú konečné, vrátane všetkých daní. Všetky ceny sú aktualizované a platné.
            </Paragraph>
            <Paragraph>
                Nefunkčnosť aplikácie nie je dôvod na vrátenie alikvotnej časti členského poplatku.
            </Paragraph>

            <SectionHeading>Podmienky používania aplikácie</SectionHeading>
            <Paragraph>
                Objednávateľ berie na vedomie a súhlasí, že poskytované informácie majú informatívny
                charakter a nie sú spracovávané a prezentované ako informácie na mieru pre konkrétneho
                užívateľa ale pre širokú verejnosť. Zároveň berie na vedomie, že Poskytovateľ
                nezaručuje, že každý užívateľ pri uplatňovaní jeho rád, dosiahne želaný výsledok,
                nakoľko výsledok ovplyvňuje aj rýchlosť reakcie, kurzové rozdiely, ovplyvnenie výsledku
                iným podnetom, ktoré Poskytovateľ nemôže ovplyvniť a nemá na to dosah. Preto pokiaľ
                Objednávateľ nedosiahne želaného výsledku, nie je to dôvod na vrátenie členského
                poplatku.
            </Paragraph>
            <Paragraph>
                Ak nie je uvedené inak, celý text, videá, služby a ostatné informácie uvedené
                v aplikácií sú duševným vlastníctvom Poskytovateľa. V aplikácií je dovolené sledovať
                videá, články pokiaľ si ich Objednávateľ zakúpil.
            </Paragraph>
            <Paragraph>
                Nie je dovolené poskytovať prístup tretím osobám, ktoré si ho nezakúpili. Pokiaľ
                Poskytovateľ zistí porušenie tohto pravidla, má právo zrušiť platený obsah v aplikácií
                bez nároku na vrátenie členského poplatku.
            </Paragraph>
            <Paragraph>
                Ak Poskytovateľ zistí takéto závažné porušenie povinností Objednávateľom, tak je
                oprávnený žiadať o úhradu zmluvnej pokuty vo výške 5000 eur a to do 15 dní od doručenia
                výzvy Objednávateľovi, ktorý sa tohto konania dopustil. Úhradou zmluvnej pokuty však
                nezaniká nárok Poskytovateľa na náhradu škody, ktorá vznikla takýmto konaním
                Objednávateľa.
            </Paragraph>
            <Paragraph>
                Nie je dovolené publikovať obsah aplikácie, videá alebo články na internete (na inej
                webovej stránke, na stránkach na zdieľanie súborov, na stránkach na zdieľanie videí či
                na sociálnej sieti).
            </Paragraph>
            <Paragraph>
                Prevádzkovateľ si vyhradzuje právo možnosti ukončiť členstvo Objednávateľa skôr ako
                uplynie lehota jedného mesiaca, ak sa Objednávateľ správa neúctivo, urážlivo voči
                Poskytovateľovi alebo ostatným Objednávateľom.
            </Paragraph>
            <Paragraph>
                Predčasným ukončením členstva nevzniká nárok na vrátenie zaplateného členského poplatku
                ani jeho alikvotnej čiastky.
            </Paragraph>

            <SectionHeading>Informácie o rizikách</SectionHeading>
            <Paragraph>
                Poskytovateľ výslovne upozorňuje Objednávateľa, že stávkovanie na športové zápasy je
                aktivita zahŕňajúca riziká.
            </Paragraph>
            <Paragraph>
                Objednávateľ výslovne uznáva, že straty dosiahnuté pri stávkovaní na športové zápasy
                a kurzovú ponuku znáša v plnom rozsahu sám a Poskytovateľ v tomto prípade nenesie
                žiadnu zodpovednosť.
            </Paragraph>
            <Paragraph>
                Rozhodnutie Objednávateľa o stavení sumy je jeho individuálnym, slobodným a vážnym
                rozhodnutím, za ktoré Poskytovateľ v žiadnom prípade nezodpovedá.
            </Paragraph>
            <Paragraph>
                Poskytovateľ nezodpovedá Objednávateľovi za straty, ktoré mu vzniknú v dôsledku
                stávkovania.
            </Paragraph>

            <SectionHeading>Ochrana osobných údajov</SectionHeading>
            <Paragraph>
                Poskytovateľ rešpektuje dôverný charakter dát, ktoré sú mu poskytované v súlade so
                Zákonom o ochrane osobných údajov a GDPR a zabezpečuje ich ochranu proti zneužitiu.
                Dáta sú predovšetkým používané na účtovné operácie, vystavenie daňových dokladov,
                identifikáciu bezhotovostných platieb a v rámci administratívy.
            </Paragraph>

            <SectionHeading>Riešenie sporov</SectionHeading>
            <Paragraph>
                Tieto VOP sa riadia právom Slovenskej republiky s vylúčením kolíznych noriem, ktoré by
                odkazovali na použitie cudzieho práva.
            </Paragraph>
            <Paragraph>
                Právom Slovenskej republiky sa spravujú právne vzťahy medzi Poskytovateľom
                a Objednávateľom aj vtedy, ak Objednávateľ nie je občanom Slovenskej republiky alebo
                nemá na jej území pobyt alebo sídlo, ako aj v prípade, že Služba sa poskytuje mimo
                územia Slovenskej republiky.
            </Paragraph>
            <Paragraph>
                V prípade akéhokoľvek sporu medzi Poskytovateľom a Objednávateľom, vzniknutého
                v súvislosti s týmito VOP sa Poskytovateľ a Objednávateľ zaväzujú vynaložiť najvyššie
                možné úsilie, ktoré je možné od nich spravodlivo požadovať, aby spory vyriešili
                mimosúdnou cestou a dosiahli uzavretie zmieru na základe vzájomnej dohody.
            </Paragraph>
            <Paragraph>
                V prípade, že nedôjde k vyriešeniu sporu mimosúdnou cestou a uzavretiu zmieru budú
                všetky spory medzi Poskytovateľom a Objednávateľom rozhodované príslušnými súdmi
                Slovenskej republiky podľa všeobecne záväzných právnych predpisov Slovenskej republiky.
            </Paragraph>

            <SectionHeading>Záverečné ustanovenia</SectionHeading>
            <Paragraph>
                Tieto VOP sú záväzné pre všetkých Objednávateľov aplikácie Góly a Esá. Pred zaplatením
                členského poplatku sú všetci Objednávatelia povinní sa riadne oboznámiť s aktuálnym
                znením VOP a zaväzujú sa nimi riadiť a dodržiavať ich.
            </Paragraph>
            <Paragraph>
                V prípade, že akékoľvek ustanovenie týchto VOP sa stane neplatným, neúčinným,
                nevykonateľným, tak nie je tým dotknutá platnosť, účinnosť, vykonateľnosť ostatných
                ustanovení týchto VOP. Neplatné, neúčinné, nevykonateľné ustanovenie sa nahradí v čo
                najkratšej dobe novým platným ustanovením.
            </Paragraph>
            <Paragraph>
                Tieto VOP budú počas celej doby ich platnosti zverejnené v aplikácií Góly a Esá,
                pričom Poskytovateľ si vyhradzuje právo kedykoľvek vykonávať zmeny alebo dodatky
                týchto VOP bez predchádzajúceho súhlasu Objednávateľa. Takto upravené alebo zmenené
                alebo doplnené VOP je Poskytovateľ povinný bezodkladne zverejniť v aplikácií Góly
                a Esá.
            </Paragraph>
            <Paragraph>
                Tieto VOP nadobúdajú platnosť a účinnosť dňom ich zverejnenia v aplikácií Góly a Esá.
            </Paragraph>

            <NewVersionNotice>
                <NoticeTitle>Táto verzia už neplatí</NoticeTitle>
                <NoticeText>
                    Toto je archivovaná verzia obchodných podmienok. Pre aktuálne platné znenie
                    obchodných podmienok prosím navštívte našu novú stránku.
                </NoticeText>
                <NewVersionLink to="/podmienky">
                    Prejsť na aktuálne obchodné podmienky
                </NewVersionLink>
            </NewVersionNotice>
        </PageContainer>
    );
};

export default TermsOfServiceArchive;
